import React, { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';

import { DocumentsFilter } from '@components/Profile/Documents/DocumentsFilter';
import { DocumentsInfo } from '@components/Profile/Documents/DocumentsInfo';
import { DocumentsTable } from '@components/Profile/Documents/DocumentsTable';
import { profileApi } from '@reducers/profile/profile';
import { skipToken } from '@reduxjs/toolkit/query';

export const Documents = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [profileID, setProfileID] = useState(
    location.state ? location.state.profileID : null
  );

  const documents = profileApi.useGetDocumentsListQuery(
    profileID ? { id: profileID } : skipToken
  );
  return (
    <>
      <Card className="mb-2">
        <Card.Header className="bg-didxl text-white" />
        <Card.Body>
          <Row>
            <Col md={5}>
              <DocumentsFilter
                profileID={profileID}
                setProfileID={setProfileID}
              />
            </Col>
            <Col md={7}>
              <DocumentsInfo />
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card>
        <Card.Header className="bg-didxl text-white">Documents</Card.Header>
        <Card.Body>
          <DocumentsTable
            data={documents.data || []}
            isLoading={documents.isLoading}
          />
        </Card.Body>
      </Card>
      {location.state && location.state.showExit ? (
        <Row>
          <Col>
            <Button
              className="mt-2"
              variant="didxl"
              size="sm"
              style={{ minWidth: '100px' }}
              onClick={() => navigate(-1)}
            >
              Exit
            </Button>
          </Col>
        </Row>
      ) : null}
    </>
  );
};
